export default __webpack_public_path__ + "static/bg3-728c29b95d7b077535441b524e7601a1.jpg";